import React from 'react';

import CardTooltip from '../CardTooltip';

import * as Svgs from './svgs';

function Icon({ name, tooltip, color, size = 20, type = 'outlined', style, ...rest }) {
    let attachStyles = {};

    if (name === 'attachment') {
        attachStyles = {
            transform: 'rotate(270deg)',
        };
    }

    function RenderIcon() {
        return (
            <span
                className={`material-icons-${type} material-icon`}
                style={{ color, fontSize: size, ...attachStyles, ...style }}
                {...rest}
            >
                {name}
            </span>
        );
    }

    if (name === 'ArrowDown') return <Svgs.ArrowDownIcon color={color} size={size} />;
    if (name === 'ArrowUp') return <Svgs.ArrowUpIcon color={color} size={size} />;
    if (name === 'ArrowLeft') return <Svgs.ArrowLeftIcon color={color} size={size} />;
    if (name === 'ArrowRight') return <Svgs.ArrowRightIcon color={color} size={size} />;
    if (name === 'CheckCircle') return <Svgs.CheckCircleIcon color={color} size={size} />;
    if (name === 'ErrorIcon') return <Svgs.ErrorIcon color={color} size={size} />;
    if (name === 'StatusTriangleIcon') return <Svgs.StatusTriangleIcon color={color} size={size} />;
    if (name === 'CheckCircleIcon') return <Svgs.CheckCircleIcon color={color} size={size} />;
    if (name === 'CircleIcon') return <Svgs.CircleIcon color={color} size={size} />;
    if (name === 'StatusCircleIcon') return <Svgs.StatusCircleIcon color={color} size={size} />;

    return tooltip ? (
        <CardTooltip message={tooltip}>
            <RenderIcon />
        </CardTooltip>
    ) : (
        <RenderIcon />
    );
}

export default Icon;
